// import React, { useEffect, useState } from 'react';
// import { Table, Button, Image, notification } from 'antd';
// import { useNavigate } from 'react-router-dom';
// import { fetchAllPayments } from '../../../service/admin/transactionService';
// import BreadcrumbComponent from '../../CssComponents/BreadCrumbComponents';
// import { approveUserBuyItem } from '../../../service/admin/approveTransaction';

// const Payments = () => {
//     const navigate = useNavigate();
//     const [payments, setPayments] = useState([]);

//     const breadcrumbItems = [
//         { name: 'Dashboard', url: '/superadmin/dashboard' },
//         { name: 'Payments' },
//     ];
//     const handleAccept = async (record) => {
//         const { itemId, uid } = record || {};
//         console.log('Accept clicked — itemId:', itemId, 'uid:', uid);

//         try {
//           const count = await approveUserBuyItem(uid, itemId);
//           notification.success({
//             message: 'Approved',
//             description: `Updated ${count} entr${count === 1 ? 'y' : 'ies'} for user ${uid}.`,
//             placement: 'topRight',
//           });

//           // (Optional) reflect something in UI if your payments rows track status
//           setPayments(prev => prev.map(p => p.id === record.id ? { ...p, status: 'approved' } : p));
//         } catch (err) {
//           console.error(err);
//           notification.error({
//             message: 'Approval failed',
//             description: err.message || 'Could not approve item.',
//             placement: 'topRight',
//           });
//         }
//       };
//     useEffect(() => {
//         const loadPayments = async () => {
//             const data = await fetchAllPayments();
//             setPayments(data);
//         };

//         loadPayments();
//     }, []);

//     const columns = [
//         {
//             title: 'Amount',
//             dataIndex: 'amount',
//             key: 'amount'
//         },
//         {
//             title: 'User ID',
//             dataIndex: 'uid',
//             key: 'uid'
//         },
//         {
//             title: 'Item ID',
//             dataIndex: 'itemId',
//             key: 'itemId'
//         },
//         {
//             title: 'Created At',
//             dataIndex: 'createdAt',
//             key: 'createdAt',
//             render: (timestamp) => new Date(timestamp).toLocaleString()
//         },
//         {
//             title: 'Reason',
//             dataIndex: 'reason',
//             key: 'reason',
//         },
//         {
//             title: 'Proof',
//             dataIndex: 'proofUrls',
//             key: 'proofUrls',
//             render: (urls) => (
//                 <div className="flex gap-2">
//                     {urls.map((url, index) => (
//                         <Image
//                             preview
//                             key={index}
//                             src={url}
//                             alt={`Proof ${index + 1}`}
//                             className="!h-20 !w-24 object-cover object-top overflow-hidden rounded"
//                         />
//                     ))}
//                 </div>
//             )
//         },
//         {
//             title: 'Actions',
//             key: 'actions',
//             fixed: 'right',
//             render: (_, record) => (
//                 <div className="flex gap-2">
//                     <Button type="primary" onClick={() => handleAccept(record)}>
//                         Accept
//                     </Button>
//                     <Button type="default" onClick={() => { }}>
//                         Reject
//                     </Button>
//                 </div>
//             )
//         }
//     ];

//     return (
//         <div className="p-6 flex flex-col gap-4">
//             <BreadcrumbComponent items={breadcrumbItems} />
//             <Table
//                 dataSource={payments}
//                 columns={columns}
//                 rowKey="id"
//                 scroll={{ x: 'max-content' }}
//                 className="shadow-md w-full overflow-auto"
//             />
//         </div>
//     );
// };

// export default Payments;
import React, { useEffect, useState } from "react";
import { Table, Button, Image, notification } from "antd";
import { useNavigate } from "react-router-dom";
import {
  fetchAllPayments,
  updateTransactionStatus,
} from "../../../service/admin/transactionService";
import BreadcrumbComponent from "../../CssComponents/BreadCrumbComponents";

const Payments = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);

  const breadcrumbItems = [
    { name: "Dashboard", url: "/superadmin/dashboard" },
    { name: "Payments" },
  ];

  useEffect(() => {
    const loadPayments = async () => {
      const data = await fetchAllPayments();
      setPayments(data);
    };
    loadPayments();
  }, []);

  // Handle status updates: Accept / Reject / Undo
  const handleStatusUpdate = async (record, status) => {
    try {
      await updateTransactionStatus(record.id, status); // Firestore update
      setPayments((prev) =>
        prev.map((p) => (p.id === record.id ? { ...p, status } : p))
      );

      const messageMap = {
        approved: "Payment accepted",
        rejected: "Payment rejected",
        pending: "Status reset to pending",
      };

      notification.success({
        message: messageMap[status],
        placement: "topRight",
      });
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Update failed",
        description: err.message || "Could not update transaction status.",
        placement: "topRight",
      });
    }
  };

  const columns = [
    { title: "Amount", dataIndex: "amount", key: "amount" },
    { title: "User ID", dataIndex: "uid", key: "uid" },
    { title: "Item ID", dataIndex: "itemId", key: "itemId" },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (timestamp) => new Date(timestamp).toLocaleString(),
    },
    { title: "Reason", dataIndex: "reason", key: "reason" },
    {
      title: "Proof",
      dataIndex: "proofUrls",
      key: "proofUrls",
      render: (urls) => (
        <div className="flex gap-2">
          {urls.map((url, index) => (
            <Image
              preview
              key={index}
              src={url}
              alt={`Proof ${index + 1}`}
              className="!h-20 !w-24 object-cover object-top overflow-hidden rounded"
            />
          ))}
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      render: (_, record) => {
        if (!record.status || record.status === "pending") {
          return (
            <div className="flex gap-2">
              <Button
                type="primary"
                onClick={() => handleStatusUpdate(record, "approved")}
              >
                Accept
              </Button>
              <Button
                type="default"
                onClick={() => handleStatusUpdate(record, "rejected")}
              >
                Reject
              </Button>
            </div>
          );
        }

        return (
          <div className="flex gap-2 items-center">
            <span
              className={`px-2 py-1 rounded ${
                record.status === "accepted"
                  ? "bg-green-200 text-green-800"
                  : "bg-red-200 text-red-800"
              }`}
            >
              {record.status.charAt(0).toUpperCase() + record.status.slice(1)}
            </span>

            <Button
              type="link"
              danger
              onClick={() => handleStatusUpdate(record, "pending")}
            >
              Undo
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="p-6 flex flex-col gap-4">
      <BreadcrumbComponent items={breadcrumbItems} />
      <Table
        dataSource={payments}
        columns={columns}
        rowKey="id"
        scroll={{ x: "max-content" }}
        className="shadow-md w-full overflow-auto"
      />
    </div>
  );
};

export default Payments;
